import { useMakeModelKeywordSearch } from './MakeModelKeywordSearch.hook';

import { KeywordSearch } from './subcomponents/KeywordSearch/KeywordSearch';

import type {
  MakeModelKeywordSearchProps,
  MakeModelOption,
} from './MakeModelKeywordSearch.typed';

/**
 * A search interface for filtering vehicles by make, model, and keywords.
 *
 * Renders different UI based on screen size.
 */
export const MakeModelKeywordSearch = (props: MakeModelKeywordSearchProps) => {
  const {
    modalDisplayConfig,
    dropdownDisplayConfig,
    minPrice,
    maxPrice,
    minYear,
    maxYear,
    makes,
    onSelectOption,
  } = props;

  const { data: makeModelOptions } = useMakeModelKeywordSearch({
    minPrice,
    maxPrice,
    minYear,
    maxYear,
  });

  const onSelect = (option: MakeModelOption) => {
    onSelectOption({
      make: option.value?.make,
      model: option.value?.model,
    });
  };

  return (
    <KeywordSearch
      onSelect={onSelect}
      initialItems={makes}
      makeModelOptions={makeModelOptions}
      modalDisplayConfig={modalDisplayConfig}
      dropdownDisplayConfig={dropdownDisplayConfig}
    />
  );
};
